<template>
  <div>
    <!-- Products list -->
    <div class="nv-grid-row">
      <div class="nv-grid-col nv-px-0">
        <h4>
          {{ $t('get_help') }}
        </h4>
        <p class="nv-mb-0">
          {{ $t('pick_your_product_or_service') }}
        </p>
      </div>
    </div>

    <div class="nv-grid-row nv-grid-multiline">
      <div class="nv-grid-col nv-grid-col-12 nv-px-0">
        <ul class="products-list nv-d-grid nv-my-2">
          <nuxt-link v-for="(prod, pIdx) of data" :key="pIdx" :to="localePath(`/support/products/${prod.slug}`)" @click="(e: Event) => setProduct(e, prod.slug)">
            <li class="product-card">
              <div class="nv-d-flex">
                <img :src="prod.logo?.url" :alt="prod.name">
                <div class="nv-d-flex nv-align-items-center">
                  <strong class="nv-mb-1">
                    {{ prod.name }}
                  </strong>
                </div>
              </div>
            </li>
          </nuxt-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IPayloadCMSProducts } from '~/server/api/support/[region]/types';
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Hooks
// ---------------------------------------

const { t } = useI18n();
const localePath = useLocalePath();
const { $cms } = useNuxtApp();
const productStore = useProductStore();
// -----------------------------------
// Hooks
// -----------------------------------
const { localeProperties } = useI18n();
const {status, error, data } = await useFetch<IPayloadCMSProducts['docs']>(`/api/support/${localeProperties.value.region}/products?language_code=en`,
  {
    key: `productsGridSupport:${localeProperties.value.code}:${localeProperties.value.language}`,
    lazy: true,
    immediate: true,
  }
);


function setProduct(e: Event, productSlug: string) {
  e.preventDefault();
  const product = data.value?.find((prod) => prod.slug === productSlug)!;

  productStore.set(product);
}

</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.products-list {
  list-style: none;

  li {
    color: initial;
  }
}

.products-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    padding: 16px;
    min-width: 240px;

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 40px;
      margin-right: 8px;
      width: 40px;
    }
  }
}
</style>
